var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.604 6.307a6.733 6.733 0 0 1 9.52 9.52l-.015.015-3.29 3.29a6.734 6.734 0 0 1-10.153-.727 1.25 1.25 0 1 1 2.002-1.498 4.234 4.234 0 0 0 6.383.457l3.282-3.281a4.233 4.233 0 0 0-5.992-5.978 1.25 1.25 0 0 1-1.737-1.798m-5.917 4.798a6.73 6.73 0 0 1 5.581.4A1.25 1.25 0 0 1 15.07 13.7a4.23 4.23 0 0 0-5.023.722l-3.282 3.282a4.233 4.233 0 0 0 5.992 5.977 1.25 1.25 0 1 1 1.737 1.799 6.733 6.733 0 0 1-9.52-9.52l.015-.016 3.29-3.29a6.7 6.7 0 0 1 2.408-1.548",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;